import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { relativeTime, dateWithYear } from '../../utils/format';
import { useLocale } from '../../contexts/LocaleContext';
import { staggerContainer, riseItem } from '../../utils/motion';
import type { TimelineEntry } from '../../types/booking';
const label: Record<string, string> = {
  requested: 'Requested',
  quoted: 'Quote sent',
  quote_revised: 'Quote revised',
  confirmed: 'Confirmed',
  in_progress: 'In progress',
  completed: 'Completed',
  review_left: 'Review left',
  cancelled: 'Cancelled',
  declined: 'Declined'
};
export function BookingTimeline({
  entries
}: {
  entries: TimelineEntry[];
}) {
  const reduce = useReducedMotion();
  const {
    locale
  } = useLocale();
  return <motion.ol variants={staggerContainer(0.05)} initial="hidden" animate="show" className="relative space-y-4 pl-1" data-id="element-103" data-mp="2i35c1aqenpu0">
      <span className="absolute left-[8px] top-2 h-[calc(100%-1rem)] w-px bg-hairline" aria-hidden="true" data-id="element-104" data-mp="2n1qdfdhe8fk1" />
      {entries.map(entry => {
      const bad = entry.status === 'cancelled' || entry.status === 'declined';
      return <motion.li key={`${entry.status}-${entry.at}`} variants={riseItem(reduce, 10)} className="flex gap-3" data-id="element-105" data-mp="uqgoc05p1uua">
            <span className={`relative z-10 mt-0.5 flex h-[17px] w-[17px] shrink-0 items-center justify-center rounded-full border-2 ${bad ? 'border-danger bg-danger' : 'border-primary bg-primary'}`} aria-hidden="true" data-id="element-106" data-mp="13oslym4z9sw8">
              <CheckIcon className="h-2.5 w-2.5 text-on-primary" data-id="element-107" data-mp="pp12i5vozkau" />
            </span>
            <span className="min-w-0" data-id="element-108" data-mp="pr43fkyduxuc">
              <span className="block text-sm font-medium text-ink" data-id="element-109" data-mp="kxsw7ipnsf1w">{label[entry.status] ?? entry.status}</span>
              <span className="block text-[12px] text-ink-3" data-id="element-110" data-mp="3td2qw5r7yhzn">
                {dateWithYear(entry.at, locale)} · {relativeTime(entry.at, locale)}
              </span>
              {entry.note && <span className="mt-0.5 block text-[13px] text-ink-2" data-id="element-111" data-mp="1scen5vqz1z0b">{entry.note}</span>}
            </span>
          </motion.li>;
    })}
    </motion.ol>;
}